import styled from "styled-components";

interface PlayerContainerProps {
  showCursor: boolean;
}

interface ControlsContainerProps {
  showControls: boolean;
}

export const PlayerContainer = styled.div<PlayerContainerProps>`
  position: relative;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  aspect-ratio: 16/9;
  background-color: black;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
  cursor: ${props => props.showCursor ? 'default' : 'none'};
`;

export const FirstLoadOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10;
`;

export const PlayButton = styled.button`
  display: flex;
  background-color: rgba(37, 185, 7, 0.7);
  color: white;
  border: none;
  border-radius: 50%;
  padding: 12px;
  transition: all 0.3s;
  transform: scale(1);
  cursor: pointer;
  font-size: 4rem;

  &:hover {
    background-color: rgba(37, 185, 7, 0.9);
    transform: scale(1.1);
  }
`;

export const ControlsContainer = styled.div<ControlsContainerProps>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 8px 16px;
  transition: opacity 0.3s;
  opacity: ${props => props.showControls ? 1 : 0};
  pointer-events: ${props => props.showControls ? 'auto' : 'none'};
`;

export const ControlButton = styled.button`
  color: white;
  font-size: 1.5rem;
  background: none;
  border: none;
  padding: 4px 6px;
  margin-right: 6px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:focus {
    outline: none;
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const VolumeControl = styled.div`
  display: none;
  flex-grow: 0.3;
  
  @media (min-width: 768px) {
    display: flex;
  }
`;

export const VolumeSlider = styled.div`
  padding: 0 12px;
  margin-right: 4px;
  border-radius: 6px;
  display: flex;
  flex-grow: 1;
  align-items: center;
`;

export const LiveIndicator = styled.div`
  display: flex;
  align-items: center;
`;

export const LiveDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #dc2626;
  border-radius: 50%;
  margin-right: 4px;
`;

export const LiveText = styled.span`
  color: white;
  font-weight: bold;
  font-size: 0.875rem;
`;

export const FlexSpacer = styled.div`
  flex-grow: 1;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.25);
  z-index: 20;
`; 